<template>
    <button @click="handleClick"  :class="size=='mini'?'axj-button':'axj-max-button'" :style="hollow?'border-color:'+color+';background-color:#ffffff;color:'+color:'background-color:'+color+';color:#ffffff'+';border-color:'+color">
      <slot></slot>
    </button>
</template>

<script>
export default {
  name: "axj-button",
  props:{
    color:{
      type:String,
      default:"red"
    },
    //空心
    hollow:{
      type:Boolean,
      default: false
    },
    size:{
      type:String,
      default:"mini"
    },
    isDisabled:{
      type:Boolean,
      default:false
    }
  },
  created() {
    this.handleCss()
  },
  methods:{
    handleClick(){
      this.$emit("click")
    },
    handleCss(){
      //this.$refs.axjButton.style.width=200+"px"
      console.log(this.$refs.axjButton)
    }
  }
}
</script>

<style slot-scope lang="scss">

button[class=axj-button]{
  margin: 0;
  padding: 0;
  border: 1px solid transparent;  //自定义边框
  outline: none;
  font-size: 14.6px;
  color: #ffffff;
  cursor: pointer;
  font-style: normal;
  font-weight: normal;
  line-height: 21.186px;
  width: 54px;
  border-radius: 5px;
  letter-spacing: 0.046em;
}

button[class=axj-max-button]{
  margin: 0;
  padding: 0;
  border: 1px solid transparent;  //自定义边框
  outline: none;
  font-size: 14.6px;
  color: #ffffff;
  cursor: pointer;
  font-style: normal;
  font-weight: normal;
  line-height: 34.186px;
  width: 70px;
  border-radius: 5px;
  letter-spacing: 0.046em;
}
</style>



// WEBPACK FOOTER //
// src/components/axj-button/index.vue